
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SportsCategories from '../home/components/SportsCategories';
import LiveMatches from '../home/components/LiveMatches';
import BannerAd from '../../components/feature/BannerAd';

import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getLiveCategorys, getLiveList } from '../../services/live';
export default function Live() {
  // 分类统一为对象类型
  const [selectedSport, setSelectedSport] = useState<{ name: string } | null>({ name: '全部' });
  const [liveCategories, setLiveCategories] = useState<any[]>([]);
  const settingConfigInfo = useSelector((state: any) => state.settings.configInfo);
  console.log('settingConfigInfo:', settingConfigInfo);
  // 分类对象数组，和首页/新闻页保持一致
  const categories = [
    { name: '全部' },
    { name: '足球' },
    { name: '篮球' },
    { name: '网球' },
    { name: '乒乓球' },
    { name: '羽毛球' },
    { name: '排球' },
    { name: '游泳' },
    { name: '田径' },
    { name: '电竞' },
    { name: 'F1' }
  ];
    useEffect(() => {
  
      // 获取直播分类
      getLiveCategorys().then((res: any) => {
        if (res && res.status === 1 && Array.isArray(res.data)) {
          setLiveCategories(res.data);
        }
      });
  
      

    }, []);
  

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main>
  {/* 体育分类选择，统一对象传递，补全 categories 参数 */}
  <SportsCategories imageServer={settingConfigInfo?.image_server} categories={liveCategories} onCategorySelect={setSelectedSport} selectedCategory={selectedSport} />
        
        {/* 直播内容区域 - 全宽布局 */}
        <section className="py-8 md:py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="bg-white rounded-lg shadow-sm p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-bold text-gray-900">
                  {!selectedSport || selectedSport.name === '全部'
                    ? '全部体育直播'
                    : `${selectedSport.name}直播`}
                </h2>
                <div className="flex items-center text-sm text-gray-500">
                  <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse mr-2"></div>
                  实时更新
                </div>
              </div>
              
              {/* 直播模块 - 传递专门的布局参数 */}
              <LiveMatches selectedSport={selectedSport} isLivePage={true} />
            </div>
          </div>
        </section>
        
        {/* 底部横幅广告 */}
        <section className="py-4 md:py-6 bg-gray-50">
          <div className="container mx-auto px-4">
            <BannerAd size="large" position="bottom" />
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
}
